module.exports = __webpack_public_path__ + "media/LMB_Garden3.9fe213fe.mp3";